import { render } from "./TournamentScheduleSeniForm.vue?vue&type=template&id=8847a31e&scoped=true"
import script from "./TournamentScheduleSeniForm.vue?vue&type=script&lang=js"
export * from "./TournamentScheduleSeniForm.vue?vue&type=script&lang=js"

import "./TournamentScheduleSeniForm.vue?vue&type=style&index=0&id=8847a31e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8847a31e"]])

export default __exports__